"use client"
import React from 'react'

interface Props {
  targetId?: string;
}

const ShowDetailsBtn = ({ targetId = 'fullDetails' }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById(targetId);
    if (el) {
      const yOffset = -80; // Account for sticky navbar height
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Show store details"
      className="group/btn inline-flex items-center gap-2 bg-white/10 hover:bg-indigo-600 border border-white/20 text-white font-bold text-xs px-6 py-3.5 rounded-xl transition-all duration-300 shadow-lg backdrop-blur-sm cursor-pointer"
    >
      <span>SHOW DETAILS</span>
      <svg className="w-4 h-4 transform group-hover/btn:translate-y-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  );
};

export default ShowDetailsBtn;
